import Dialog from '@/components/common/Popup/dialog';
import SupportPopupWrapper from '@/components/support-popup/content';
import { PopupProps } from '@/components/common/Popup';

export const parsePopupLink = (link: string) => {
  try {
    const url = new URL(link);
    const popupKey = url.searchParams.get('__popup_key__');
    const showMode = url.searchParams.get('__showmode__');
    const popupHeight = url.searchParams.get('__popup_height__');
    return {
      popupKey,
      showMode,
      popupHeight
    };
  } catch (e) {
    return null;
  }
};

export function checkWebPopupFromUrl(url, dialogStyle?: Partial<PopupProps>, t?, lang?, cb?: (popupkey?) => void) {
  const popupInfo = parsePopupLink(url as string);
  const { popupKey, showMode, popupHeight } = popupInfo || {};
  let showPop = false; //默认跳转页面
  // 有弹窗组件显示弹窗
  if (showMode === 'popup') {
    showPop = true;
  }

  if (!!cb) {
    cb(showPop ? popupKey : null);
    return;
  }
  if (showPop) {
    loadPopupByKey(popupKey, url, dialogStyle, t, lang);
  } else {
    window.location.href = url;
  }
}

export function loadPopupByKey(key, url, dialogStyle?: Partial<PopupProps>, t?, lang?) {
  // 默认样式-从底部弹出有阴影限高可滑动的弹窗，可用dialogStyle覆盖
  const _dialog = Dialog({
    position: 'bottom',
    animationType: 'slide-up',
    wrapperClassName: 'rounded-t-500 overflow-hidden',
    ...dialogStyle,
    content: (
      <div className="max-h-[calc(100vh-220px)] overflow-y-auto box-border relative">
        <SupportPopupWrapper
          url={url}
          componentKey={key}
          isPopup={false}
          visible={true}
          onCancel={() => {
            _dialog.close();
          }}
          t={t}
          lang={lang}
        />
      </div>
    )
  });
}
